import {request} from './request'
// 创建订单--提交订单的时候获取
export function createOrder(params){
    // params为地址
    return request({
        // 接口
        url:'/api/orders',
        // 提交方法
        method:'post',
        params
    })
}

// 订单预览
export function getOrderPreview(){
    return request({
        // 接口
        url:'/api/orders/preview'
    })
}

// 订单支付,获取二维码
export function payOrder(order,params){
    // order为id
    return request({
        // 接口
        url:`/api/orders/${order}/pay`,
        // 获取用什么支付
        params
    })
}

// 查询订单支付的状态
export function payOrderStatus(order){
    // order为id
    return request({
        // 接口
        url:`/api/orders/${order}/status`,
    })
}

//订单列表 {page:1,status:2,include:'goods,user,orderDetail'}
export function getOrderList(params){
    return request({
        url:'/api/orders',
        method:'get',
        params
    })
}

// 订单的详情
export function getOrderDetail(order){
    return request({
        url:`/api/orders/${order}`,
        params:{
            include:'user,orderDetails.goods'
        }
    })
}

// 确认订单
export function confirmOrder(order){
    return request({
        url:`/api/orders/${order}/confirm`,
        method:'patch'
    })
}


// 获取物流状态
export function viewExpress(order){
    return request({
        url:`/api/orders/${order}/express`
    })
}
